import React from 'react';
import {formatCurrency} from './PublicLineItems';

function QuoteSummary({
  baseTotalCents=0,
  selectedExtrasTotalCents=0,
  acceptedSnapshot=null
}) {
  const hasAcceptedSnapshot=Boolean(acceptedSnapshot);
  const baseCents=hasAcceptedSnapshot
    ? Number(acceptedSnapshot.base_total_cents || 0)
    : Number(baseTotalCents || 0);
  const extrasCents=hasAcceptedSnapshot
    ? Number(acceptedSnapshot.extras_total_cents || 0)
    : Number(selectedExtrasTotalCents || 0);
  const subtotalCents=hasAcceptedSnapshot
    ? Number(acceptedSnapshot.subtotal_ex_gst_cents || 0)
    : baseCents + extrasCents;
  const gstCents=hasAcceptedSnapshot
    ? Number(acceptedSnapshot.gst_cents || 0)
    : Math.round(subtotalCents * 0.1);
  const totalCents=hasAcceptedSnapshot
    ? Number(acceptedSnapshot.total_inc_gst_cents || 0)
    : subtotalCents + gstCents;

  return (
    <aside className="quote-summary">
      <span className="eyebrow">Quote Summary</span>

      <div className="summary-lines">
        <div>
          <span>Base quotation</span>
          <strong>{formatCurrency(baseCents)}</strong>
        </div>

        <div>
          <span>Selected optional extras</span>
          <strong>{formatCurrency(extrasCents)}</strong>
        </div>

        <div className="summary-subtotal">
          <span>Subtotal ex GST</span>
          <strong>{formatCurrency(subtotalCents)}</strong>
        </div>

        <div>
          <span>GST 10%</span>
          <strong>{formatCurrency(gstCents)}</strong>
        </div>
      </div>

      <div className="summary-total">
        <span>Total including GST</span>
        <strong>
          {formatCurrency(totalCents)}
          <small>AUD</small>
        </strong>
      </div>

      <p>Quotation valid for 30 days. All amounts are in Australian dollars.</p>
    </aside>
  );
}

export default QuoteSummary;